import React from 'react';
import StandardPriceGroup from './standardPriceGroup/StandardPriceGroup';
import OptionsSummary from './optionSummary/OptionSummary';
import Fees, { AboveTheLineFees } from './fees/Fees';
import Translate from '../../../core/translate/Translate';
import PackageSavings from './packageSavings/PackageSavings';
import TotalVehiclePrice from './totalVehiclePrice/TotalVehiclePrice';
import AboveTheLineIncentives from './aboveTheLineIncentives/AboveTheLineIncentives';
import BelowTheLineIncentives from './belowTheLineIncentives/BelowTheLineIncentives';
import NetPriceGroup from './NetPriceGroup';
import DealerInstalledAccessories from './dealerInstalledAccessories/DealerInstalledAccessories';

const MathBoxWrapper = ({ children }) => (
  <div className="math-box">{children}</div>
);

const MathBox = ({ pricing, config, analyticsKey }) => {
  return (
    <MathBoxWrapper>
      <div className="math-box__header">
        <Translate value="summary" />
      </div>
      <StandardPriceGroup pricing={pricing} />
      <OptionsSummary
        config={config}
        pricing={pricing}
        analyticsKey={analyticsKey}
      />
      <Fees pricing={pricing} />
      {!!pricing.opdTotal && <PackageSavings pricing={pricing} />}
      <TotalVehiclePrice pricing={pricing} />
      {pricing.incentives.lines.length > 0 && (
        <AboveTheLineIncentives pricing={pricing} />
      )}
      <AboveTheLineFees pricing={pricing} />
      <NetPriceGroup pricing={pricing} config={config} />
      <DealerInstalledAccessories config={config} pricing={pricing} />
      <BelowTheLineIncentives pricing={pricing} />
    </MathBoxWrapper>
  );
};
export default MathBox;
